import React, { useState, useEffect } from "react";
import { EuiProvider } from "@elastic/eui";
import Header from "../components/Header";
import HomeComponent from "../components/Home/Home";

const Home = () => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const themeLight = "/white.css"; // Asegúrate de que la ruta es correcta
    const themeDark = "/dark.css"; // Asegúrate de que la ruta es correcta

    const loadTheme = (themePath) => {
      const head = document.head;
      const link = document.createElement("link");

      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = themePath;

      // Intenta encontrar el enlace existente y removerlo
      const existingLink = document.getElementById("theme-style");
      if (existingLink) {
        head.removeChild(existingLink);
      }

      link.id = "theme-style";
      head.appendChild(link);
    };

    if (theme === "dark") {
      loadTheme(themeDark);
    } else {
      loadTheme(themeLight);
    }

    // Limpieza al desmontar el componente o cambiar el tema
    return () => {
      const existingLink = document.getElementById("theme-style");
      if (existingLink) {
        document.head.removeChild(existingLink);
      }
    };
  }, [theme]);

  const changeTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <EuiProvider colorMode={theme}>
      <div>
        <Header changeTheme={changeTheme} theme={theme} />
        <div style={{ marginTop: 10, marginLeft: 4 }}>
          <HomeComponent />
        </div>
      </div>
    </EuiProvider>
  );
};

export default Home;
